import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class BagUiService {
  readonly open = signal(false);

  show(): void {
    this.open.set(true);
    document.body.classList.add('basel-cart-opened');
  }

  hide(): void {
    this.open.set(false);
    document.body.classList.remove('basel-cart-opened');
  }
}
